import React, { useState } from 'react';
import '../../style/style.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, Form, FormGroup, Modal } from 'react-bootstrap';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { L10n } from '@syncfusion/ej2-base';
import ToastComponent from '../toastComponent'; // Renamed to avoid conflict with react-bootstrap/Toast

// Os ícones podem ser do bootstrap-icons, font-awesome, ou SVGs customizados.
// Por simplicidade, usaremos texto.
library.add(fas);

const ModalAttachment = ({ showAttachModal, setShowAttachModal }) => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showErrorToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    L10n.load({
        'pt-BR': {
            uploader: {
                invalidMinFileSize: 'O tamanho do arquivo é muito pequeno!',
                invalidMaxFileSize: 'O tamanho do arquivo excede o limite!',
                invalidFileType: 'Tipo de arquivo não permitido!',
                browse: 'Selecionar',
                clear: 'Limpar',
                upload: 'Enviar',
                dropFilesHint: 'ou arraste e solte os arquivos aqui',
                remove: 'Remover',
                retry: 'Tentar novamente',
                delete: 'Excluir',
                totalFiles: '${count} arquivo(s)',
                size: 'tamanho',
                failedMessage: 'Erro ao enviar o arquivo',
                pausedMessage: 'Envio pausado',
                inProgress: 'Enviando...',
                readyToUploadMessage: 'Pronto para enviar',
                removeSuccessMessage: 'Arquivo removido com sucesso',
                removeFailedMessage: 'Falha ao remover arquivo',
                fileUploadCancel: 'Cancelado'
            }
        }
    });


    const handleBeforeUpload = async (args) => {
        args.cancel = true;

        const formData = new FormData();
        formData.append('FileRequest', args.filesData[0].rawFile);
        formData.append('Database', window.database_type);
        formData.append('UserName', localStorage.getItem("mestre"));
        formData.append('ThreadId', sessionStorage.getItem("OpenAi_threadId"));
        formData.append('QueryType', 0);

        try {
            const response = await fetch(`${window.ai_api_service}api/OpenAi/SendFileToOpenAiAssistantRequest`, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();

            let uploadedIds = [];

            const existingIds = sessionStorage.getItem('OpenAi_UploadedFileIds');
            if (existingIds) {
                try {
                    uploadedIds = JSON.parse(existingIds);
                    if (!Array.isArray(uploadedIds)) uploadedIds = [];
                } catch {
                    uploadedIds = [];
                }
            }
            uploadedIds.push(responseData.fileId);

            sessionStorage.setItem('OpenAi_UploadedFileIds', JSON.stringify(uploadedIds));

            setShowAttachModal(false);
            setToastMessage("Dados enviados com sucesso!");
            setShowToast(true);
        } catch (error) {
            console.error('Erro no upload:', error);
            setError('Falha ao enviar arquivo! Erro: ' + error);
        }
    };

    return (
        <>
            <Modal show={showAttachModal} onHide={() => setShowAttachModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enviar dados para o assistente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <UploaderComponent
                            locale="pt-BR"
                            id="fileUpload"
                            type="file"
                            selected={handleBeforeUpload} // ← TROQUE AQUI
                            multiple={false}
                            autoUpload={true}
                            allowedExtensions=".jpg,.png,.pdf,.csv,.xlsx,.txt"
                        />

                    </FormGroup>
                </Modal.Body>
                {/* The Alert component can remain if you want to show a persistent error inside the modal */}
                {error &&
                    <Alert variant={'danger'} className='mr-2 ml-2'>
                        <FontAwesomeIcon icon="exclamation-circle" className="mr-2" />
                        {error}
                    </Alert>
                }
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAttachModal(false)}>
                        Fechar
                    </Button>

                    <Button variant="primary" onClick={() => sendDataToAssistant()} disabled={isLoading}>
                        {isLoading ? 'Enviando...' : 'Enviar'}
                    </Button>
                </Modal.Footer> */}
            </Modal>
            {/* Toast component for errors */}
            <ToastComponent
                show={showErrorToast}
                setShow={setShowToast}
                title="Dados Enviados!"
                content={toastMessage}
            />
        </>
    );
};

export default ModalAttachment;